import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getApprovalsRouterLink} from "root/Wieldy/routePaths";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {MessageTypeFilters} from "root/DataFunctions/Constants";
import phpVars from 'phpVars';

const ApprovalsAppSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    // Ensure we always have a default filter ( From the URL or a default )
    const message_filter_type = queryParams.type === undefined ? MessageTypeFilters.MESSAGE_TYPE_ALL : queryParams.type;

    const approvalsSubmenu =() =>{
        return(
            <AppSidebarGroup title='Filters' default={message_filter_type}>
                {phpVars.has_lifestory && <AppSidebarMenuItem link={getApprovalsRouterLink('?type=' + MessageTypeFilters.MESSAGE_TYPE_ALL)} title='All' iconName='icon-files' name={MessageTypeFilters.MESSAGE_TYPE_ALL} />}
                {phpVars.has_lifestory && <AppSidebarMenuItem link={getApprovalsRouterLink('?type=' + MessageTypeFilters.MESSAGE_TYPE_LIFESTORY)} title='Posts' iconName='icon-camera' name={MessageTypeFilters.MESSAGE_TYPE_LIFESTORY}/>}
                <AppSidebarMenuItem link={getApprovalsRouterLink('?type=' + MessageTypeFilters.MESSAGE_TYPE_MESSAGE)} title='Messages' iconName='icon-chat' name={MessageTypeFilters.MESSAGE_TYPE_MESSAGE}/>
            </AppSidebarGroup>
        )
    }

    return (
        <Fragment>
            { approvalsSubmenu ()}
        </Fragment>
    )
}

export default ApprovalsAppSubmenu ;